import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronRight } from "react-icons/fa";
import { AiOutlineCloseCircle } from "react-icons/ai"; // Import the close icon
import LoadingScreen from "../components/LoadingScreen"; // Import LoadingScreen
import Navbar from "../components/Navbar"; // Import Navbar
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles

const Partner = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPartner, setSelectedPartner] = useState(null); // State for the selected partner

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once
    });
  }, []);

  // Fetch partner details from the API
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get("https://shatabackend.in/partners");
        setPartners(response.data); // Assuming the API returns an array of partner objects
      } catch (error) {
        console.error("Error fetching partner details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  // Function to toggle card expansion
  const toggleCard = (partner) => {
    setSelectedPartner(partner); // Set the selected partner for the modal
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedPartner(null); // Clear the selected partner
  };

  if (loading) {
    return <LoadingScreen />; // Use LoadingScreen while loading
  }

  return (
    <div className="shadow-md min-h-screen flex flex-col items-center justify-center bg-white">
      <Navbar /> {/* Render Navbar */}
      <h1 className="text-2xl font-bold my-6" data-aos="slide-up">
        Partner Details
      </h1>
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-7xl"
        data-aos="slide-up"
      >
        {partners
          .filter((partner) => {
            // Exclude partners with the name "Shekhar"
            if (partner.name === "Shekhar") {
              return false;
            }

            // Check for missing details
            const requiredFields = [
              "name",
              "personalEmail",
              "mobileNo",
              "companyName",
              "designation",
              "companyEmail",
              "companyLocation",
              "gstNo",
              "cinNo",
              "aadharNo",
              "gstCertificateUrl",
              "incorporationCertificateUrl",
              "governmentIdUrl",
              "aadharUrl",
            ];

            const missingDetails = requiredFields.filter(
              (field) => !partner[field] || partner[field] === "string"
            );

            // Add missingDetails to the partner object
            partner.missingDetails = missingDetails;

            // Only include partners with missing details
            return missingDetails.length > 0;
          })
          .map((partner, index) => (
            <div
              key={index}
              className="border rounded-lg p-6 shadow-md bg-white"
              data-aos="slide-up"
            >
              <h2 className="text-lg font-bold mb-4">
                {partner.name || "No User Name"}
              </h2>
              <p className="text-sm text-gray-600">
                Personal Email: {partner.personalEmail || "Missing"}
              </p>
              <button
                onClick={() => toggleCard(partner)}
                className="flex items-center mt-4 text-orange-500 hover:underline cursor-pointer"
              >
                View Missing Details <FaChevronRight className="ml-2" />
              </button>
            </div>
          ))}
      </div>

      {/* Modal for Missing Details */}
      {selectedPartner && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-orange-500 hover:text-orange-600 text-2xl"
            >
              <AiOutlineCloseCircle /> {/* Close icon */}
            </button>
            <h2 className="text-lg font-bold mb-4">
              {selectedPartner.name || "No User Name"}
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Personal Email: {selectedPartner.personalEmail || "Missing"}
            </p>
            <h3 className="text-md font-semibold mb-2">Missing Details:</h3>
            <ul className="list-disc pl-4">
              {selectedPartner.missingDetails.map((field) => (
                <li key={field} className="text-sm text-red-500">
                  {field}: {selectedPartner[field] || "Missing"}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Partner;